var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welfare-details"},[_c('div',{staticClass:"news-content"},[_c('div',{staticClass:"main-content"},[_c('img',{attrs:{"src":_vm.imgSrc}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }